"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var _default = exports["default"] = (0, _reactIntl.defineMessages)({
  criticalIconTitle: {
    id: 'components.Alert.criticalIconTitle',
    defaultMessage: 'Uma exclamação com um circulo ao redor'
  },
  defaultIconTitle: {
    id: 'components.Alert.defaultIconTitle',
    defaultMessage: 'Uma exclamação com um circulo ao redor'
  },
  positiveIconTitle: {
    id: 'components.Alert.positiveIconTitle',
    defaultMessage: 'Uma letra v simbolizando sucesso, com um circulo ao redor'
  },
  warningIconTitle: {
    id: 'components.Alert.warningIconTitle',
    defaultMessage: 'Uma exclamação com um triangulo ao redor'
  },
  informationIconTitle: {
    id: 'components.Alert.informationIconTitle',
    defaultMessage: 'Balão de informação'
  }
});